import { useState, useEffect } from "react";
import { launchTransak } from "../steps/launchTransak";
import { useGlobalContext } from "../context/GlobalContext/GlobalContext";
import { useSmartAccountContext } from "../context/SmartAccountContext/SmartAccountContext";
import { useNavigate } from "react-router-dom";
import Pusher from "pusher-js";
import { useWeb3AuthContext } from "../context/SocialLoginContext/SocialLoginContext";

function Widget() {
  const navigate = useNavigate();
  const { queryParams, setTransakOrderData }: any = useGlobalContext();
  const { selectedAccount }: any = useSmartAccountContext();
  const { userInfo } = useWeb3AuthContext()
  let initialButtonName = "Stake Crypto";

  const [buttonName, setButtonName] = useState("");

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    if (queryParams && queryParams.widgetTitle) initialButtonName = queryParams.buttonName;
    setButtonName(initialButtonName);
  }, [queryParams]);

  const openTransak = () => {
    console.log(queryParams, "queryParams");

    const transakParams = {
      apiKey: queryParams.apiKey ? queryParams.apiKey : "3758451a-36b9-4f92-a8a5-192bdf9d76de",
      environment: queryParams.environment ? queryParams.environment : "STAGING",
      defaultCryptoCurrency: queryParams.symbol ? queryParams.symbol : "APOLDAI",
      walletAddress: queryParams.walletAddress ? queryParams.walletAddress : selectedAccount && selectedAccount.smartAccountAddress,
      fiatCurrency: queryParams.fiatCurrency ? queryParams.fiatCurrency : "EUR",
      network: queryParams.network ? queryParams.network : "polygon",
      partnerOrderId: queryParams.partnerOrderId && queryParams.partnerOrderId,
      /** User Info From Social Login */
      email: userInfo?.email
    };
    console.log(transakParams, "transakParams");

    const transakWidget = launchTransak(transakParams);
    console.log(transakWidget, "transakWidget");

    if (transakWidget) {
      transakWidget.init();

      // This will trigger when the user marks payment is made.
      transakWidget.on(transakWidget.EVENTS.TRANSAK_ORDER_SUCCESSFUL, async (orderData: any) => {
        setTransakOrderData(orderData);

        let pusher = new Pusher("1d9ffac87de599c61283", { cluster: "ap2" });
        let orderId = orderData.status.id;

        //to subscribe
        let channel = pusher.subscribe(orderId);

        // need to conisder ORDER_COMPLETED event, but since there is an issue with that event, we are doing this.
        channel.bind(`ORDER_COMPLETED`, (orderData: any) => {
          console.log(orderData, "onlyOrderId");
          transakWidget.close();
          navigate("/success");
        });

        channel.bind(`ORDER_FAILED`, (orderData: any) => {
          console.log(orderData, "onlyOrderId");
          transakWidget.close();
          navigate("/failed");
        });
      });
    }
  };

  return (
    <div style={{ height: "100%", position: "relative" }}>
      <div className="px-4 py-20 sm:px-10 mt-20">
        <div>
          <div className="flex items-center space-x-4  border border-gray-300 px-8">
            <div className="flex-shrink-0 flex items-center">
              <img src={"https://app.aave.com/icons/tokens/aave.svg"} alt="aave" width="40" height="40" />
              <span className="ml-2">AAVE</span>
            </div>
            <div className="min-w-0 flex-1 justify-end mr-2 items-end flex flex-col	py-0">
              <p className="truncate text-sm font-medium text-gray-900  mt-2 mb-0">Staking APY</p>
              <p className="truncate text-sm text-gray-500 mt-0">8.30%</p>
            </div>
          </div>
          <div className="mt-6">
            <button className="flex w-full justify-center rounded-md text-aave-100  bg-gradient-to-r from-aave-500  to-aave-800 lg:inline py-2 px-4" onClick={() => openTransak()}>
              {buttonName}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Widget;
